import 'flowbite';
import './bootstrap.cjs';
import 'maz-ui/css/main.css'
import '../css/app.css';

import {createApp, h} from 'vue';
import {createInertiaApp} from '@inertiajs/inertia-vue3';
import {InertiaProgress} from '@inertiajs/progress';
import {ZiggyVue} from '../../vendor/tightenco/ziggy/dist/vue.m.js';
import {VueTheMask} from 'vue-the-mask'
import vClickOutside from "click-outside-vue3"
import HeaderNavigation from "@/Layouts/HeaderNavigation.vue";
import SidebarNavigation from "@/Layouts/SidebarNavigation.vue";
import md5 from "md5";

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

const helpers = {
    md5: md5,
    fullName: (user) => {
        let fullName = user.firstname;
        if (user.lastname) {
            fullName += ` ${user.lastname}`;
        }

        return fullName;
    },
    userIsEmployee: (user) => {
        return parseInt(user.employeeType) === 0;
    },
    userIsVendor: (user) => {
        return parseInt(user.employeeType) === 1;
    },
    userIsCompanyContact: (user) => {
        return parseInt(user.employeeType) === 2;
    },
    userIsSales: (user) => {
        return parseInt(user.employeeType) === 3;
    },
    userIsInventory: (user) => {
        return parseInt(user.employeeType) === 4;
    },
    userIsSalesPerson: (user) => {
        return parseInt(user.employeeType) === 5;
    },
    userIsAdmin: (user) => {
        return parseInt(user.employeeType) === 6;
    },
    userIsProjectManager: (user) => {
        return parseInt(user.employeeType) === 7;
    },
    userCanManageProject: (user) => {
        return [0, 5, 6, 7].includes(parseInt(user.employeeType));
    },
    userHasPermission: (user, permission) => {
        return user.permission[permission] === 'on';
    }
}
const filters = {
    currencyUSD(value) {
        if (isNaN(value) || value == null) return '';
        return '$' + value
      }
}

if (window.location.pathname.endsWith('.php')) {
    const app = createApp({}).use(ZiggyVue).use(VueTheMask).use(vClickOutside);
    app.config.globalProperties.$helpers = helpers;
    app.config.globalProperties.$filters = filters;
    app.config.compilerOptions.isCustomElement = (tag) => ['center', 'font'].includes(tag);
    const sideApp = createApp({}).use(ZiggyVue).use(VueTheMask).use(vClickOutside);
    sideApp.config.globalProperties.$helpers = helpers;
    sideApp.config.globalProperties.$filters = filters;
    sideApp.config.compilerOptions.isCustomElement = (tag) => ['center', 'font'].includes(tag);
    app.component('Navigation', HeaderNavigation).mount('#navigation');
    sideApp.component('Sidebar', SidebarNavigation).mount('#sidebar');
} else {
    createInertiaApp({
        title: (title) => `${title} - ${appName}`,
        resolve: (name) => require(`./Pages/${name}.vue`),
        setup({el, app, props, plugin}) {
            const appInstance = createApp({render: () => h(app, props)})
                .use(plugin)
                .use(ZiggyVue, Ziggy)
                .use(VueTheMask)
                .use(vClickOutside);
            appInstance.config.globalProperties.$helpers = helpers;
            appInstance.config.globalProperties.$filters = filters;

            return appInstance.mount(el);
        },
    });

    InertiaProgress.init({color: '#4B5563'});
}
